import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'

import Lightbox from './lightbox'

export default class Publication extends Component {
  constructor(props) {
    super(props)
    this.state = {
      publication: { Excerpt: '', Description: '', Synopsis: '', Images: [] },
      shownTab: 'text',
      selectedPhotoIndex: -1
    }
  }

  setSelectedPhotoIndex(index) {
    this.setState({ selectedPhotoIndex: index })
  }

  getPublicationByApi(slug) {
    var url =
      (process.env.NODE_ENV === 'development'
        ? API_BASE_URL_DEV
        : API_BASE_URL_PROD) +
      'publications/slug=' +
      slug

    fetch(url, {})
      .then(response => response.json())
      .then(json =>
        this.setState({
          publication: json,
          selectedPhotoIndex: json.Images.length > 0 ? 0 : -1
        })
      )
    // .then(json => this.setState({publication: json}))
  }

  componentDidMount() {
    this.getPublicationByApi(this.props.slug)
  }

  // will be called by a route change
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.slug !== this.props.slug) {
      this.getPublicationByApi(this.props.slug)
    }
  }

  render() {
    let description = null
    if (this.state.publication.Description !== '<p><br></p>') {
      description = (
        <div
          className="publication-description"
          dangerouslySetInnerHTML={{
            __html: this.state.publication.Description
          }}
        />
      )
    }
    return (
      <div className="publication">
        <Lightbox
          photos={this.state.publication.Images}
          selectedPhotoIndex={this.state.selectedPhotoIndex}
          setSelectedPhotoIndex={this.setSelectedPhotoIndex.bind(this)}
        />
        <div className="publication-excerpt">
          <span className="publication-excerpt-person" />
          <span
            className="publication-excerpt-text"
            dangerouslySetInnerHTML={{ __html: this.state.publication.Excerpt }}
          />
        </div>
        {description}
      </div>
    )
  }
}

Publication.propTypes = {
  slug: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/front/components/publication.js